import styled, { css } from 'styled-components';
import { EInputSize } from './config';

export const InputContainer = styled.div`
  position: relative;
  width: 100%;
`;

export const InputBase = styled.input<{
  $hasError: boolean;
  $disabled: boolean;
  $size: EInputSize;
}>`
  display: block;
  width: 100%;
  border-radius: 6px;
  border: 1px solid hsl(214, 32%, 91%);
  background-color: white;
  font-size: 14px;
  line-height: 1.5;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  outline: none;
  color: hsl(224, 71%, 4%);

  /* Size variants */
  ${(props) =>
    props.$size === EInputSize.SM &&
    css`
      height: 32px;
      padding: 0 8px;
      font-size: 12px;
    `}

  ${(props) =>
    props.$size === EInputSize.DEFAULT &&
    css`
      height: 40px;
      padding: 0 12px;
    `}

  ${(props) =>
    props.$size === EInputSize.LG &&
    css`
      height: 48px;
      padding: 0 16px;
      font-size: 16px;
    `}

  /* States */
  &:focus {
    border-color: hsl(221, 83%, 53%);
    box-shadow: 0 0 0 2px hsl(221, 83%, 53%, 0.2);
  }

  ${(props) =>
    props.$hasError &&
    css`
      border-color: hsl(0, 84%, 60%);
      &:focus {
        box-shadow: 0 0 0 2px hsl(0, 84%, 60%, 0.2);
      }
    `}

  ${(props) =>
    props.$disabled &&
    css`
      background-color: hsl(220, 14%, 96%);
      cursor: not-allowed;
      opacity: 0.7;
    `}

  &::placeholder {
    color: hsl(215, 20%, 65%);
  }
`;

export const InputError = styled.div`
  margin-top: 4px;
  font-size: 12px;
  color: hsl(0, 84%, 60%);
`;

export const InputLabel = styled.label`
  display: block;
  margin-bottom: 8px;
  font-size: 14px;
  font-weight: 500;
  color: hsl(224, 71%, 4%);
`;

export const InputAddon = styled.div`
  display: flex;
  align-items: center;
  padding: 0 12px;
  background-color: hsl(220, 14%, 96%);
  border: 1px solid hsl(214, 32%, 91%);
  color: hsl(215, 20%, 65%);
  font-size: 14px;
`;